// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__VDJve","col":"styles_col__3QT2S"};